module.exports = __webpack_public_path__ + "media/images/travel-231143419076cd86a85f6320a75836b3.png";